import { QueryClient } from '@tanstack/react-query'

import { captureError } from '../../instrumentation-client'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      gcTime: 1_000 * 60 * 60 * 24, // 24 hours
      refetchOnWindowFocus: true,
      refetchInterval: 20000,
      retry: 3,
      retryDelay: (attemptIndex) => Math.min(300 * 2 ** attemptIndex, 10_000),
      staleTime: 30000,
    },
  },
})

queryClient.getQueryCache().subscribe(({ query }) => {
  if (query.state.status === 'error') {
    captureError(query.state.error)
  }
})

queryClient.getMutationCache().subscribe(({ mutation }) => {
  if (mutation && mutation.state.status === 'error') {
    captureError(mutation.state.error)
  }
})
